import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
class About extends Component {
    render() {
        return (
            <div>
                 <section class="get-abtstarted-section text-center">
                        <center>
                        <h1 class="text-header-title btn-getstarted" >
                        ABOUT US 
                        </h1>
                        </center>
                  </section>

                   <div aria-label="breadcrumb">
           
                        <ol class="breadcrumb " >
                        <li class="breadcrumb-item"> <Link href=""><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                        <li class="breadcrumb-item active">ABOUT</li>
                        </ol>
                    </div>

                    <section class="course-why-epn padding-default" id="course-why-epn">
                        <div class="row">
                        <div class="col-sm-12">
                            <h2>Why edu plus now</h2>
                            <br />
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="box_feat">
                                    <img src="/assets/images/icons/whyepn1.svg" alt="whyepn1" />
                                    <h3>Industry-Ready Courses</h3>
                                    <p>Learn industry-relevant skills that’ll make your resume stand out and ensure
                                        you’re ready to
                                        tackle the job market. 
                                    </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="box_feat">
                                    <img src="/assets/images/icons/whyepn2.svg" alt="whyepn2" />
                                    <h3>Flexible Learning</h3>
                                    <p>Access online learning resources anywhere, anytime to gain valuable skills and
                                        transform your
                                        life in meaningful ways.
                                    </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="box_feat">
                                    <img src="/assets/images/icons/whyepn3.svg" alt="whyepn3" />
                                    <h3>Qualified Instructors</h3>
                                    <p>Connect with experts and qualified instructors from reputed universities to stay
                                        on top of the
                                        ever-evolving future of work.
                                    </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="box_feat">
                                    <img src="/assets/images/icons/whyepn4.svg" alt="whyepn4" />
                                    <h3>Adavanced study plans</h3>
                                    <p>Learn complex technical skills with videos, quizzes and assignments to develop
                                        your career and
                                        build towards a degree. 
                                    </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="box_feat">
                                    <img src="/assets/images/icons/whyepn5.svg" alt="whyepn5" />
                                    <h3>Focus on target</h3>
                                    <p>Select the best online courses in India that are not only informative and
                                        helpful to your
                                        long-term career goals but also help close the skill gap in the industry.
                                    </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="box_feat">
                                    <img src="/assets/images/icons/whyepn6.svg" alt="whyepn6" />
                                    <h3>Knowledge Platform</h3>
                                    <p>Take advantage of a complete in-built environment for programming and get
                                        hands-on experience to
                                        solve real-world problems practically. 
                                    </p>
                                    </div>
                                </div>
                            </div>                          
                        </div>
                        </div>
                    </section>
                    <section class="default-pd bg-blues">
                            <div class="row">
                                <div class="col-sm-12">
                                <div class="main_title_2">
                                    <br />
                                    <br />
                                    <span><em></em></span>
                                    <h2>Our Origins and Story</h2>
                                    <p>
                                        <b>Creating Opportunities for Lifelong Learning</b>
                                    </p>
                                    <br />
                                </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="row justify-content-between">
                                <div class="col-lg-6 wow" data-wow-offset="150">
                                    <figure class="block-reveal">
                                        <div class="block-horizzontal"></div>
                                        <img dir="images" src="/assets/images/about_origin.jpg"  class="img-fluid" alt="about" />
                                    </figure>
                                </div>
                                <div class="col-md-6 col-sm-12" id="content" >
                                    <p>
                                        edu plus now is an online educational platform that was launched in 2019 to bridge the skill gap between classroom learning, real business challenges and to help students achieve their career potential.
                                        <br /><br />
                                        Aimed at providing learners with essential technical skills, edu plus now courses are created to be the perfect amalgamation of inputs from industry experts and highly-qualified professors from the country’s top educational institutions. This allows individuals and companies to close the skill gap quickly, innovate faster and achieve their key objectives. At edu plus now, we believe in preparing students for success in a changing world by providing online courses that pave the path for a successful career. Built under the aegis of the Vishwakarma Group, the online education platform provides flexible learning that fits a learner’s schedule
                                    </p>
                                </div>
                                </div>
                            
                            </div>
                    </section>

            </div>
        );
    }
}

export default About;